module.exports = __webpack_public_path__ + "assets/img/632500.b2480622.png";